import React, { Component } from 'react';

import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonBackButton,
  IonSkeletonText,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonButtons,
  IonButton,
  IonItem,
  IonLabel,
  IonIcon,
  IonList,
  IonThumbnail,
  IonImg,
  IonText,
} from '@ionic/react';

import { arrowForwardOutline as forward } from 'ionicons/icons';

import SearchService from '../services/product';

import Price from '../components/Price';
import AuthResource from '../resources/Auth';
import CartResource from '../resources/Cart';

import { cartOutline as cart } from 'ionicons/icons';

import '../theme/ionIconStack.scss';

export default class CategoryPage extends Component {
  constructor(props) {
    super(props);

    this.loader = React.createRef();

    this.state = {
      title: "",
      categories: undefined,
      selectedCategory1: null,
      selectedCategory2: null,
      checkCategories: null,
      currentPage: 1,
      requestPerPage: 12,
      fetching: true,
      disabledInfiniteScroll: true,
      prods: [],
      messages: [],
    };

    this.openCat = this.openCat.bind(this);
    this.addProductToCart = this.addProductToCart.bind(this);
    this.infiniteScrollHandler = this.infiniteScrollHandler.bind(this);
  }

  async componentDidMount() {
    try {
      let level = [];
      if (this.props.match.params.category1 !== undefined) {
        level[0] = this.props.match.params.category1;
        if (this.props.match.params.category2 !== undefined) {
          level[1] = this.props.match.params.category2;
          if (this.props.match.params.category3 !== undefined) {
            level[2] = this.props.match.params.category3;
          }
          if (this.props.match.params.category4 !== undefined) {
            level[3] = this.props.match.params.category4;
          }
        }
      }
      const response = await SearchService.getCategory();
      let formattedCategories = [];
      switch (level.length) {
        case 0:
          if (response.data && Array.isArray(response.data)) {
            formattedCategories = response.data
              .filter(item => item.categoria2_slug === '')
              .map(item => ({
                id: item.id,
                categoria1: item.categoria_pf1,
                categoria2: item.categoria_pf2,
                slug1: item.categoria1_slug,
                slug2: item.categoria2_slug,
                hero_title: item.hero_title,
                description: item.description,
                last_update: item.last_update,
                tot_prodotti: item.tot_prodotti ? parseInt(item.tot_prodotti, 10) : 0,
              }));
            await this.setState({ showCategory: true });
            await this.setState({ categories: formattedCategories });
            await this.setState({ disabledInfiniteScroll: true });
          }
          break;
        case 1:
          if (response.data && Array.isArray(response.data)) {
            formattedCategories = response.data
              .filter(item => item.categoria1_slug === level[0] && item.categoria2_slug !== '')
              .map(item => ({
                id: item.id,
                categoria1: item.categoria_pf1,
                categoria2: item.categoria_pf2,
                slug1: item.categoria1_slug,
                slug2: item.categoria2_slug,
                hero_title: item.hero_title,
                description: item.description,
                last_update: item.last_update,
                tot_prodotti: item.tot_prodotti ? parseInt(item.tot_prodotti, 10) : 0,
              }));
            if (formattedCategories.length > 0) {
              await this.setState({ showCategory: true });
              await this.setState({ categories: formattedCategories });
              await this.setState({ disabledInfiniteScroll: true });
            } else {
              await this.setState({ showCategory: false });
              let selectedCategory = response.data.find(
                item => item.categoria1_slug === level[0]
              );

              if (selectedCategory) {
                let categoryData = {
                  id: selectedCategory.id,
                  categoria1: selectedCategory.categoria_pf1,
                  categoria2: selectedCategory.categoria_pf2,
                  slug1: selectedCategory.categoria1_slug,
                  slug2: selectedCategory.categoria2_slug,
                  hero_title: selectedCategory.hero_title,
                  description: selectedCategory.description,
                  last_update: selectedCategory.last_update,
                  tot_prodotti: selectedCategory.tot_prodotti ? parseInt(selectedCategory.tot_prodotti, 10) : 0,
                };

                let prods = await this.searchProduct(categoryData.categoria1, '');
                await this.setState({ selectedCategory1: categoryData.categoria1 });
                await this.setState({ selectedCategory1: '' });
                await this.setState({ disabledInfiniteScroll: false });
                await this.setState({ prods: prods });
              }
            }
          }
          break;
        case 2:
          await this.setState({ showCategory: false });
          let selectedCategory = response.data.find(
            item => item.categoria1_slug === level[0] && item.categoria2_slug === level[1]
          );

          if (selectedCategory) {
            let categoryData = {
              id: selectedCategory.id,
              categoria1: selectedCategory.categoria_pf1,
              categoria2: selectedCategory.categoria_pf2,
              slug1: selectedCategory.categoria1_slug,
              slug2: selectedCategory.categoria2_slug,
              hero_title: selectedCategory.hero_title,
              description: selectedCategory.description,
              last_update: selectedCategory.last_update,
              tot_prodotti: selectedCategory.tot_prodotti ? parseInt(selectedCategory.tot_prodotti, 10) : 0,
            };

            let prods = await this.searchProduct(categoryData.categoria1, categoryData.categoria2);
            await this.setState({ selectedCategory1: categoryData.categoria1 });
            await this.setState({ selectedCategory2: categoryData.categoria2 });
            await this.setState({ disabledInfiniteScroll: false });
            await this.setState({ prods: prods });
          }


          // if (categories[par[1]] === undefined) {
          //   let prods = await this.searchProduct(categories[par[0]][par[1]]);
          //   await this.setState({ prods: prods });
          // } else {
          //   await this.setState({ searchCategories: categories[par[1]] });
          // }
          break;
        default:
          break;
      }



      await this.setState({ fetching: false });
    } catch (error) {
      console.error("Errore nel caricamento delle categorie:", error);
    }
  }


  async searchProduct(slug1, slug2) {
    let prods = this.state.prods;
    await this.setState({ disabledInfiniteScroll: false });
    await this.setState({ fetching: true });
    try {
      let search = await SearchService.searchByCategory(
        slug1,
        slug2,
        this.state.currentPage,
        this.state.requestPerPage
      );


      // L'endpoint restituisce la risposta Elasticsearch grezza (nessun totPages):
      // il totale sta in hits.total.value.
      const hits = search.data.hits?.hits ?? [];
      const totHits = search.data.hits?.total?.value ?? 0;
      const totPages = Math.ceil(totHits / this.state.requestPerPage);

      prods = hits.map((e) => {
        return e._source;
      });

      prods = this.state.prods.concat(prods);

      // hits.total puo' essere approssimato per eccesso (relation "gte"), quindi
      // ci si ferma anche quando la pagina torna meno prodotti del richiesto.
      if (
        hits.length < this.state.requestPerPage ||
        this.state.currentPage >= totPages
      ) {
        await this.setState({ disabledInfiniteScroll: true });
      }
    } catch (error) {
      // senza disabilitare lo scroll una richiesta fallita verrebbe ritentata all'infinito
      await this.setState({ disabledInfiniteScroll: true });
      prods = this.state.prods;
    }
    await this.setState({ fetching: false });
    await this.setState({ prods: prods });

    return prods;
  }

  async openCat(category) {
    this.props.history.push('/app/category' + category);
  }

  async infiniteScrollHandler(e) {
    await this.setState({ currentPage: this.state.currentPage + 1 });
    let prods = await this.searchProduct(this.state.selectedCategory1, this.state.selectedCategory2);
    await this.setState({ prods });
    e.target.complete();
  }

  async addProductToCart(prod, nome_prodotto = 'Prodotto') {
    if (!!!(await AuthResource.isLogged)) {
      this.props.toast.current.add({
        message: `Accedi o registrati`,
        color: 'warning',
      });
      this.props.history.push('/auth/login');
      return;
    }

    await CartResource.addProduct(prod);
    this.props.toast.current.add({
      message: `${nome_prodotto} aggiunto al carrello`,
    });
  }

  render() {
    let categoryItems = [];
    if (this.state.categories && this.state.categories.length > 0) {
      categoryItems = this.state.categories.map((category) => {
        const label = category.categoria2 || category.categoria1;
        let slug = category.slug1;
        slug = category.slug2 !== '' ? `/${slug}/${category.slug2}` : `/${slug}`;
        return (
          <IonItem key={category.id} onClick={() => this.openCat(slug)}>
            <IonLabel>{label.charAt(0).toUpperCase() + label.slice(1)}</IonLabel>
            <IonIcon slot="end" icon={forward} />
          </IonItem>
        );
      });
    }

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="" />
            </IonButtons>
            <IonTitle>
              {this.props.match.params.category1 !== undefined
                ? this.state.title.charAt(0).toUpperCase() + this.state.title.slice(1)
                : 'Ricerca per categorie'}
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {this.state.prods.length > 0 ? (
            this.state.prods.map((prod, key) => (
              <IonItem key={key}>
                <IonThumbnail slot="start">
                  <IonImg
                    src={
                      prod.immagine && prod.immagine !== ''
                        ? `https://d1pubfi4049q8p.cloudfront.net/ws/it/${prod.immagine}`
                        : `/assets/prodotto_generico_125.png`
                    }
                    onClick={() => this.props.history.push(`/app/product/${prod.codice_ministeriale}`)}
                  />
                </IonThumbnail>
                <IonLabel onClick={() => this.props.history.push(`/app/product/${prod.codice_ministeriale}`)}>
                  <h4 className="ion-text-capitalize">{prod.nome_prodotto}</h4>
                  <p className="ion-text-capitalize">{prod.descrizione_ditta_1_produttrice}</p>
                  <p className="price">
                    <IonText color="success">
                      <Price price={prod.prezzo} />
                      <span className="euro-symbol">€</span>
                    </IonText>
                    {/* PREZZO SCONTATO
                     prod.prezzo_bancadati <= prod.prezzo ? null : (
                      <>
                        &nbsp;
                        <span className="mainprice">
                          <Price price={prod.prezzo_bancadati} />
                          <span className="euro-symbol">€</span>
                        </span>
                      </>
                    )}
                    {prod.prezzo_bancadati > 0 &&
                      Math.round(((prod.prezzo_bancadati - prod.prezzo) / prod.prezzo_bancadati) * 100) > 5 && (
                        <IonText color="danger">
                          &nbsp; Sconto{' '}
                          {Math.round(((prod.prezzo_bancadati - prod.prezzo) / prod.prezzo_bancadati) * 100)}%
                        </IonText>
                      ) */}
                    &nbsp;
                    {prod.quantita > 0 ? <span>Disponibile</span> : <span>Da ordinare</span>}
                  </p>
                </IonLabel>
                <IonButton
                  slot="end"
                  color="light"
                  onClick={() => this.addProductToCart(prod.codice_ministeriale, prod.nome_prodotto)}
                  size="default"
                >
                  <IonIcon slot="icon-only" icon={cart} />
                </IonButton>
              </IonItem>
            ))
          ) : (
            <>
              {!!categoryItems && categoryItems.length > 0 ? (
                <IonList lines="full" className="ion-no-margin ion-no-padding">
                  {categoryItems}
                </IonList>
              ) : (
                <>
                  {!!!this.state.fetching && (
                    <>
                      <div className="ion-margin ion-padding">
                        <h1>Risultato non trovato</h1>
                        <p>La categoria cercata non è esistente</p>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
          {!!this.state.fetching && (
            <>
              {[...Array(this.state.requestPerPage).keys()].map((e, key) => (
                <IonItem key={key}>
                  <IonThumbnail slot="start">
                    <IonSkeletonText animated />
                  </IonThumbnail>
                  <IonLabel>
                    <h4>
                      <IonSkeletonText animated style={{ width: '50%' }} />
                    </h4>
                    <p>
                      {' '}
                      <IonSkeletonText animated style={{ width: '80%' }} />
                    </p>
                    <p>
                      {' '}
                      <IonSkeletonText animated style={{ width: '60%' }} />
                    </p>
                  </IonLabel>
                </IonItem>
              ))}
            </>
          )}
          <IonInfiniteScroll disabled={this.state.disabledInfiniteScroll} onIonInfinite={this.infiniteScrollHandler}>
            <IonInfiniteScrollContent loadingSpinner={null} />
          </IonInfiniteScroll>
        </IonContent>
      </>
    );
  }
}
